'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { Spinner } from '../spinner/spinner.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: true,
        configurable: true,
        writable: true
    }) : t[e] = n, t;
}
function _object_spread(t) {
    for(var e = 1; e < arguments.length; e++){
        var n = null != arguments[e] ? arguments[e] : {}, r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(t) {
            return Object.getOwnPropertyDescriptor(n, t).enumerable;
        }))), r.forEach(function(e) {
            _define_property(t, e, n[e]);
        });
    }
    return t;
}
function ownKeys(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n.push.apply(n, r);
    }
    return n;
}
function _object_spread_props(t, e) {
    return e = null != e ? e : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : ownKeys(Object(e)).forEach(function(n) {
        Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
    }), t;
}
function _object_without_properties(t, e) {
    if (null == t) return {};
    var n, r, o = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        for(r = 0; r < a.length; r++)n = a[r], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
    }
    return o;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var n, r, o = {}, a = Object.keys(t);
    for(r = 0; r < a.length; r++)n = a[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
    return o;
}
const Button = renderWithRef('Button', null, (r, s)=>{
    var i;
    useDeprecatedProps('Button', r, [
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode'
        },
        {
            propName: 'buttonShape',
            instructions: 'Use `IconButton` component for creating icon-only buttons'
        }
    ]);
    let { as: c, component: p, skin: d = 'secondary', size: u = 'standard', width: b = 'standard', specialVariant: l = 'standard', iconPosition: f, buttonShape: y = 'standard', children: w, type: _, loading: j } = r, O = _object_without_properties(r, [
        "as",
        "component",
        "skin",
        "size",
        "width",
        "specialVariant",
        "iconPosition",
        "buttonShape",
        "children",
        "type",
        "loading"
    ]), m = null !== (i = null != c ? c : p) && void 0 !== i ? i : 'button', h = 'button' === m || 'input' === m ? null != _ ? _ : 'button' : _, g = ![
        'unstyled',
        'clear-selection',
        'link'
    ].includes(null != d ? d : 'secondary'), P = new Set([]);
    if (g && (P.add('swan-button'), P.add(`swan-button-skin-${d}`)), g || P.add(`swan-button-skin-${d}`), 'round' === y && P.add('swan-button-round'), 'left' === f && P.add('swan-button-with-icon-left'), ('design-path' !== l || f) && 'right' !== f || P.add('swan-button-with-icon-right'), 'standard' !== u && g && P.add(`swan-button-${u}`), 'standard' === u || g || P.add(`swan-button-${u}`), 'standard' !== b && P.add(`swan-button-${b}`), 'design-path' === l && P.add("swan-button-design-path"), j && P.add('swan-button-loading'), 'input' === m) return jsx(RenderComp, {
        root: "input",
        forwardedRef: s,
        classNames: P,
        props: _object_spread_props(_object_spread({}, O), {
            type: h
        }),
        children: w
    });
    let v = _object_spread({
        'aria-disabled': j || void 0,
        type: _,
        as: m
    }, O);
    return jsxs(RenderComp, {
        root: "button",
        forwardedRef: s,
        classNames: P,
        props: 'button' === m ? _object_spread_props(_object_spread({}, v), {
            type: h
        }) : v,
        children: [
            w,
            j && jsx(Spinner, {
                accessibleText: "",
                "aria-hidden": true
            })
        ]
    });
});

export { Button };
